<template>
    <div style="color: black;">
        <div>
            <img src="../assets/bg.jpg" style="width: 100%" alt="">
        </div>
        <div style="padding: 20px">
            <div style="font-size: 16px;margin-bottom: 10px">查询条件</div>
            <el-form :model="queryParams" :rules="rules" ref="queryForm" size="medium" label-position="top"
                     label-width="68px">
                <el-form-item label="参赛选手" prop="participantName">
                    <el-input placeholder="请输入参赛选手" size="medium" v-model="queryParams.participantName"/>
                </el-form-item>
<!--                <el-form-item label="日期" prop="date">
                    <el-input placeholder="请输入日期-格式:20240827" size="medium" v-model="queryParams.date"/>
                </el-form-item>-->
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="medium" @click="handleQuery">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <img src="../assets/bottom.png" style="width: 100%" alt="">
        </div>
    </div>
</template>

<script>

import {listCompetitionQuery} from "@/api/competition/competitionQuery";

export default {
    name: "SelectPage2",
    data() {
        return {
            // 查询参数
            queryParams: {
                participantName: null,
                date: null
            },
            rules: {
                participantName: [
                    {required: true, message: "参赛选手不能为空", trigger: "blur"}
                ],
                /*date: [
                    {required: true, message: "日期不能为空", trigger: "blur"}
                ],*/
            },
        }
    },
    created() {
        document.title = this.$route.meta.title;
    },
    mounted() {

    },
    methods: {
        handleQuery() {
            this.$refs["queryForm"].validate(valid => {
                if (valid) {
                    listCompetitionQuery(this.queryParams).then(res => {
                        if (res.code === 200 && res.rows.length > 0) {
                            this.$message.success("共查询到" + res.rows.length + '条记录')
                            this.$router.push({path: '/select2/detail', query: {data: JSON.stringify(res.rows)}})
                        } else {
                            this.$message.error("查无此人")
                        }
                    })
                }
            });

        },
    }
}
</script>

<style>
#app {
    background-color: white;
}
</style>
